import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';

import {HoverHandler} from "@gisatcz/ptr-core";
import {ScatterChart} from "@gisatcz/ptr-charts";
import AttributesList from '../AttributesList';
import {Intervals, ValuesBySize, SectionHeader} from '../../Legend';
import styles from '../../../data/styles/styles';
import TrackControls from './TrackControls';
import InterferometryChart from './InterferometryChart';

class Interferometry extends React.PureComponent {
    static propTypes = {
        feature: PropTypes.object
    }

    constructor(props) {
        super(props);

    }

    render() {
        const props = this.props;
        const classes = styles.velAvg.attributeClasses;
        const sizes = styles.relCm.attributeValues;
        const noDataColor = styles.interferometryBase.fill;

        return (
            <div className="eo4sdDrrInsarMyanmar20-panel-section-content">
                <TrackControls/>
                <div className="eo4sdDrrInsarMyanmar20-panel-data-wrapper">
                    {props.feature ? (
                        <>
                            <InterferometryChart attributes={this.props.feature.properties}/>
                            <AttributesList featureProperties={this.props.feature.properties}/>
                        </>
                    ) : (
                        <p className="centered">Select point...</p>
                    )}
                </div>
                <div className="eo4sdDrrInsarMyanmar20-legend col-2">
                    <div className="eo4sdDrrInsarMyanmar20-legend-section">
                        <SectionHeader title="Annual displacement rate (mm/year)"/>
                        <Intervals classes={classes} noData={noDataColor}/>
                    </div>
                    <div className="eo4sdDrrInsarMyanmar20-legend-section">
                        <SectionHeader title="PS reliability class"/>
                        <ValuesBySize data={sizes} style={styles.interferometryBase}/>
                    </div>
                </div>
            </div>
        );
    }
}

export default Interferometry;
